import Axios from "axios"

export default {
  getApartmentSensors(zoneID) {
    return Axios.post(
      "/getApartmentsV2",
      { zoneID: zoneID },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      }
    )
  },
  getApartmentLettersInZone(zoneID) {
    return Axios.post(
      "/getApartmentLettersInZone",
      { zoneID: zoneID },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      }
    )
  },
  getApartmentsMetrics(zoneID) {
    return Axios.post(
      "/getApartmentsMetrics",
      { zoneID: zoneID },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      }
    )
  },
  getApartmentData(zoneID, floor, apartment) {
    return Axios.post(
      "/getApartmentData",
      {
        zoneID: zoneID,
        floor: floor,
        apartment: apartment,
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      }
    )
  },
  getApartmentHistory(zoneID, floor, apartment, from, to) {
    return Axios.post(
      "/getApartmentHistory",
      {
        zoneID: zoneID,
        floor: floor,
        apartment: apartment,
        from: from,
        to: to,
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
      }
    )
  },
}



// WEBPACK FOOTER //
// ./src/api/apartments.service.js